import React, { Component } from "react";
import {
  Popover,
  OverlayTrigger,
  Tab,
  Form,
  Alert,
} from "react-bootstrap";
import Select from "react-select";
import * as Icon from "react-feather";
import axios from "axios";
import { toast } from "react-toastify";
import { CSSTransition } from "react-transition-group";
import { SpecDetailsForm } from "../connectors/specDetails.js";
import ConnectorCardPush from "../connectors/connectorCardPush.js";
import WithRouter from "../../HOC/RouterWrapper";
import StepIndicator from "./StepIndicator";

import { ReactComponent as DetailsIcon } from "../../assets/img/icons/details.svg";
import DatajoltSpinner from "../global/DatajoltSpinner.js";
import { applyEditService, createPushService, editPushService, getColumnsService, getDestinationObjectsAirbyteService, getDestinationService, getMyDestinationsService, getMyModelsService, getPushTypeService, getTapDetailsService, listConnectorsService, listDagsService, refreshDestinationCatalogService, saveDestinationService, showInitialEditViewService, testDestinationService, testPushService, validateMappingService } from "../../services/push.js";
import CloseDrawerModal from "../Modals/CloseDrawer.js";
import ModalLayout from "../Modals/Layout";
import ModalLayoutContent from "../Modals/Layout/Content";
import ModalLayoutFooter from "../Modals/Layout/Footer";
import ModalLayoutBtn from "../Modals/Layout/Btn";
import {CircularProgress, Button, DialogTitle, DialogContentText, Typography, Stack, IconButton} from "@mui/material";
import Row from "../global/Layout/Row.js";
import Col from "../global/Layout/Col.js";

// A link may name more than one column, stored comma-separated ("CENTER_ID,MODEL").
// Uniqueness is a property of the combination, not of either column on its own.
const splitLink = (link) =>
  typeof link === "string" && link
    ? link.split(",").map((part) => part.trim()).filter(Boolean)
    : [];

// Rebuild react-select's value from the stored comma-separated pair.
const linkOptions = (link, labels) => {
  const asLabels = splitLink(labels);
  return splitLink(link).map((value, i) => ({ value, label: asLabels[i] || value }));
};

class Push extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fields_mapping: [{ source: "", target: "" }],
      loading: false,
      loading_destination_objects: false,
      EditOpen: false,
      getting_push_types: false,
      getting_models: true,
      datasources: [],
      progress: 40,
      spec_details: [],
      running_dags: [],
      DAGs: [],
      loading_my_destinations: false,
      loading_connectors: false,
      dag_runs: [],
      dag_pause_statuses: [],
      destination_id: "",
      gs_url: "",
      historical_dag_runs: [],
      subelements: false,
      selected_datapoint_source: false,
      json_update_endpoint: false,
      source_link: false,
      destination_link: false,
      logs_schedule: false,
      get_dags_status: true,
      push_type: false,
      selected_destination_object: false,
      selected_datapoint_destination: false,
      destination_fields: [],
      primary_keys: {},
      selected_model: false,
      mydestinations: [],
      modal_history: false,
      activeTab: "all",
      deleting_push_alias: "",
      push_alias: "",
      destination_alias: "",
      mytaps: [],
      modal_edit: false,
      modal_flow: false,
      schedule_frequency: false,
      selected_job: "",
      schedule_details: false,
      scheduling: false,
      schedule_day: false,
      dag_logs: [],
      datapoints_options: false,
      modal_lose_create_push_progress: false,
      selected_version: undefined,
      row_count: null,
      loading_row_count: false,
      validation_errors: {},
      validating_mapping: false,
      type_mapping: null,
      showTypeMapping: false,
      source_id_validation: null,
      loading_source_id_validation: false,
    };
  }

  componentDidMount() {
    window.scrollTo({
      top: 0,
    });
    document.body.style.overflow = "hidden";
    const hasInitialEditView =
      this.props.router.location.search.includes("edit_push");

    if (hasInitialEditView) {
      this.showInitialEditView();
    } else {
      this.listConnectors("destinations");
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "";
    if (this.props.setSelectedPushData) {
      this.props.setSelectedPushData({
        logo: null,
        selected_tap: "",
      });
    }
  }

  showInitialEditView = async () => {
    const edit_push_id = new URLSearchParams(window.location.search).get(
      "edit_push"
    );

    let targetDAG;

    if (this.props.dagsList.length) {
      targetDAG = this.props.dagsList.find((DAG) => DAG.id === edit_push_id);
      this.editPush(targetDAG.id, targetDAG.logo, targetDAG.subtype, targetDAG.version);
    } else {
      const response = await showInitialEditViewService();

      if(response) {
        this.setState({
          loading: false,
          DAGs: response.data.dags_list,
          dag_pause_statuses: response.data.pauses_status,
        });
    
        targetDAG = response.data["dags_list"].find(
          (DAG) => DAG.id === edit_push_id
        );
        this.editPush(targetDAG.id, targetDAG.logo, targetDAG.subtype, targetDAG.version);
        if (this.props.setSelectedPushData) {
          this.props.setSelectedPushData({
            logo: targetDAG.logo,
            selected_tap: targetDAG.subtype,
          });
        }
      }
    }
  };

  redirectToHistoryModalView = (DAG) => {
    this.props.router.navigate(`/jobs/push?history_modal=${DAG.id}`);
  };

  handleSelectChangeOneOf = (e, name, oneofs, options) => {
    const subelement_index = options
      .map((object) => object.value)
      .indexOf(e.value);
    const element_index = this.state.spec_details
      .map((object) => object.name)
      .indexOf(name);
    oneofs.forEach((oneoff) => {
      if (oneoff["title"] === e.value) {
        this.setState({
          element_index: element_index,
          subelements: oneoff["required"],
          subelement_index: subelement_index,
        });
      }
    });
  };

  handleSelectChangeEnum = (name) => (selectedvalue) => {
    this.setState({ [name]: selectedvalue.value });
  };

  handleToggle = (name) => {
    this.setState({ [name]: !this.state[name] });
  };

  getColumns = async (depends_on,table) => {
    // Don't load datapoints when editing non-v2 pushes
    if (this.isNonV2EditMode()) {
      return;
    }
    
    if (this.state.selected_tap === "Tableau") {
      this.setState({depends_on:depends_on});
      return;
    } else if (this.state.selected_tap === "Google Sheets") {
      this.setState({ selected_model: table,depends_on:depends_on});
      if (!this.state.editing) {
        this.getRowCount(table);
      }
    } else {
      if (!this.props.editorURL) {
        // Wait for props to be available, retry after component update
        setTimeout(() => this.getColumns(depends_on, table), 100);
        return;
      }
      this.setState({ loading_datapoints: true,depends_on:depends_on});
      const response = await getColumnsService(table, this.props.editorURL);

      if(response) {
        let datapoints_options = [];
        for (let data_point in response.data["columns"]) {
          datapoints_options.push({
            label: response.data["label"][data_point],
            value: response.data["columns"][data_point],
          });
        }
        this.setState({
          datapoints_options: datapoints_options,
          selected_model: response.data["table_with_case"],
        }, () => {
          // Trigger validation for edit flow if destination fields are ready
          if (this.state.editing && this.state.selected_version === "v2" && this.state.push_fields_options && this.state.fields_mapping) {
            this.validateEditMappings();
          }
        });
        if (!this.state.editing) {
          this.getRowCount(response.data["table_with_case"]);
        }
      }
      this.setState({ loading_datapoints: false });
    }
  };

  getRowCount = async (table) => {
    this.setState({ loading_row_count: true, row_count: null });
    
    try {
      const response = await axios.post(
        `${this.props.editorURL}/api/sql/submit_sql`,
        { sql: `SELECT COUNT(*) as row_count FROM ${table}`, rows: 1 }
      );
      
      const lines = response.data.split('\n').filter(line => line.trim());
      for (const line of lines) {
        try {
          const data = JSON.parse(line);
          if (data.display_results && data.display_results[0]) {
            this.setState({ row_count: data.display_results[0].row_count });
            break;
          }
        } catch (e) {}
      }
    } catch (error) {
      console.error('Error fetching row count:', error);
    }
    
    this.setState({ loading_row_count: false });
  };

  validateSourceId = async () => {
    const { selected_model, source_link } = this.state;

    console.log('validateSourceId called:', { selected_model, source_link });

    if (!selected_model || !source_link) return;

    this.setState({ loading_source_id_validation: true, source_id_validation: null });

    try {
      const columns = splitLink(source_link).map((c) => `"${c}"`);
      const query = `SELECT COUNT(*) as total_count, COUNT(DISTINCT ${columns.join(", ")}) as unique_count, COUNT(${columns[0]}) as non_null_count FROM ${selected_model}`;
      console.log('Executing validation query:', query);
      const response = await axios.post(
        `${this.props.editorURL}/api/sql/submit_sql`,
        { sql: query, rows: 1 }
      );
      
      const lines = response.data.split('\n').filter(line => line.trim());
      for (const line of lines) {
        try {
          const data = JSON.parse(line);
          if (data.display_results && data.display_results[0]) {
            const { total_count, unique_count, non_null_count } = data.display_results[0];
            const hasDuplicates = total_count !== unique_count;
            const hasNulls = non_null_count < total_count;
            const duplicateCount = total_count - unique_count;
            const nullCount = total_count - non_null_count;
            
            console.log('Validation results:', { total_count, unique_count, non_null_count, hasDuplicates, hasNulls, duplicateCount, nullCount });
            
            this.setState({ 
              source_id_validation: {
                isUnique: !hasDuplicates,
                hasNulls: hasNulls,
                totalCount: total_count,
                uniqueCount: unique_count,
                nullCount: nullCount,
                duplicateCount: duplicateCount,
                fieldName: source_link
              }
            });
            break;
          }
        } catch (e) {}
      }
    } catch (error) {
      console.error('Error validating source ID:', error);
    }
    
    this.setState({ loading_source_id_validation: false });
  };

  options_oneofs = (name, oneofs) => {
    let oneof = [];
    oneofs.forEach((oneoff) => {
      //find upper key name where order = 0 inside property key and use that variable to identify what the initial dropdown value is
      let obj = oneoff["properties"];
      let result = Object.keys(obj).find((key) => obj[key]["order"] === 0);
      if (result === undefined) {
        oneof.push({ label: oneoff["title"], value: oneoff["title"] });
      } else {
        oneof.push({
          label: oneoff["title"],
          value: oneoff["properties"][result]["const"],
        });
      }
    });
    return oneof;
  };

  options_jobs = (name, oneofs) => {
    let oneof = [];
    oneofs.forEach((oneoff) => {
      //find upper key name where order = 0 inside property key and use that variable to identify what the initial dropdown value is
      let obj = oneoff["properties"];
      let result = Object.keys(obj).find((key) => obj[key]["order"] === 0);
      if (result === undefined) {
        oneof.push({ label: oneoff["title"], value: oneoff["title"] });
      } else {
        oneof.push({
          label: oneoff["title"],
          value: oneoff["properties"][result]["const"],
        });
      }
    });
    return oneofs;
  };


  getMyModels = async (notify_user) => {
    if (!this.props.editorURL) {
      console.log('waiting on editor url to be set to get models...');
      setTimeout(() => this.getMyModels(notify_user), 100);
      return;
    }
    this.setState({ logs: false, getting_models: true });
    const response = await getMyModelsService(notify_user, this.props.editorURL);

    if(response) {
      let query_options = [];
      for (let key in response.data) {
        if (response.data.hasOwnProperty(key)) {
          query_options.push({
            label: key,
            value: response.data[key],
          });
        }
      }
      this.setState({ options: query_options });
    }
    this.setState({ getting_models: false });
  };

  toggleEditModal = (DAG) => {
    this.setState({ selected_job: DAG, modal_edit: !this.state.modal_edit });
  };

  getTapDetails = async (
    tap,
    logo,
    destination_group,
    status,
    destinationdefinitionID,
    version
  ) => {
    if (status === "Contact Us") {
      toast.info("Please contact Datajolt to set up this push", {
        autoClose: 5000,
      });
    } else {
      if (this.props.setSelectedPushData) {
        this.props.setSelectedPushData({
          logo,
          selected_tap: tap,
        });
      }
      const SelectedTap = {
        tap: tap,
        destinationdefinitionID: destinationdefinitionID,
      };
      this.setState({
        destinationdefinitionID: destinationdefinitionID,
        subelements: [],
        subelements_index: false,
        destination_group: destination_group,
        logo: logo,
        activeTab: "setup",
        progress: 40,
        loading_spinner: true,
        logs: false,
        selected_tap: tap,
        spec_details: false,
        selected_version: version,
      });
      const response = await getTapDetailsService(tap, SelectedTap, version);

      if(response) {
        this.setState({
          fields: response.data["inputs"],
          spec_details: JSON.parse(response.data["specs"]),
        });
        //CHECK FOR BOOLEANS, IF FOUND ADD TO STATE (SO IT DOESNT CRASH IF IT IS NOT TOUCHED BY USER AS ONLY FORM ELEMENTS INTERACTED WITH WILL TRIGGER A STATE UPDATE)
        JSON.parse(response.data["specs"]).map((detail) =>
          detail.type === "boolean" ? this.setState({ [detail.name]: false }) : ""
        );
      } else {
        this.setState({ spec_details: [] });
      }

      this.setState({ progress: 100, loading_spinner: false });
    }
  };

  fetchAirflowDags = async () => {
    this.setState({
      editing: false,
      get_dags_status: true,
      DAGs: [],
      loading: true,
      loading_spinner_pushes: true,
      progress: 60,
      activeTab: "all",
    });
    const response = await listDagsService();

    if(response) {
      this.setState({
        loading: false,
        DAGs: response.data["dags_list"],
        dag_pause_statuses: response.data["pauses_status"],
      });
    }
    this.setState({
      progress: 100,
      loading: false,
      loading_spinner_pushes: false,
    });
  };

  
  SelectExistingDestination = (
    destination_alias,
    logo,
    destination_id,
    destination_name,
    details,
    version
  ) => {
    if (this.props.setSelectedPushData) {
      this.props.setSelectedPushData({
        logo: logo,
        selected_tap: destination_name,
      });
    }
    this.setState({
      editing: false,
      selected_destination_object: false,
      selected_model: false,
      activeTab: "dataset",
      logo: logo,
      selected_tap: destination_name,
      destination_alias: destination_alias,
      destination_id: destination_id,
      fields: [],
      destination_objects: [],
      fields_mapping: [{ source: "", target: "" }],
      source_link_label: false,
      destination_link_label: false,
      push_type: false,
      selected_datapoint_destination: false,
      source_link: false,
      destination_link: false,
      selected_datapoint_source: false,
      selected_version: version,
    });
    if (destination_id.length < 20) {
      this.getDestinationObjects(
        destination_name,
        destination_alias,
        version
      );
    } else {
      this.getDestinationObjectsAirbyte(destination_name, destination_id);
    }
  };

  applyEdit = async () => {
    // Upsert links can name several columns and this form cannot round-trip that safely
    // yet, so saving would overwrite a working composite key. The button is disabled too;
    // this is the guard for anything that reaches the handler another way.
    if (this.state.push_type === "Upsert") {
      toast.info("Editing an Upsert push is temporarily disabled. Ask the Datajolt team to change it.");
      return;
    }
    const toastId = toast.loading("Saving your push details...");
    for (let value of this.state.fields_mapping) {
      if (!value.source || !value.target) {
        toast.error("You cannot have an empty mapping.");
        toast.dismiss(toastId);
        this.setState({ progress: 100, testing: false });
        return;
      }
    }
    
    // Check for validation errors before updating
    if (
      this.state.selected_version === "v2" &&
      Object.keys(this.state.validation_errors).length > 0
    ) {
      toast.error("Please fix the data type compatibility errors before updating the push.");
      toast.dismiss(toastId);
      this.setState({ progress: 100, testing: false });
      return;
    }
    
    this.setState({ progress: 40, testing: true });
    
    const isSuccess = await applyEditService(this.state.push_edit_dag_id, this.state.fields_mapping, this.state.source_link, this.state.destination_link, toastId)

    if(isSuccess) {
      this.props.toggleCreatePushForm();
      this.props.router.navigate("/jobs/push");
    } else {
      this.props.toggleCreatePushForm();
    }
    this.setState({ progress: 100, testing: false });
  };

  editPush = async (dag_id, logo, subtype, version) => {
    // this.getMyModels(false);
    this.setState({
      source_link_label: false,
      destination_link_label: false,
      source_link: false,
      destination_link: false,
      fields: [],
      push_fields_options: [],
      destination_objects: [],
      push_edit_dag_id: dag_id,
      push_type: false,
      progress: 40,
      editing: true,
      activeTab: "dataset",
      logo: logo,
      selected_tap: subtype,
      destination_id: "pending",
      selected_version: version || "v1", // Set the version immediately
    });
    if (this.props.setSelectedPushData) {
      this.props.setSelectedPushData({
        logo: logo,
        selected_tap: subtype,
      });
    }
    const response = await editPushService(dag_id);

    if(response) {
      this.setState({
        fields_mapping: response.data["mappings"],
        selected_destination_object:
          response.data["selected_destination_object"],
        selected_model: response.data["selected_model"],
        push_alias: response.data["alias"],
        destination_id: response.data["destination_id"],
        destination_alias: response.data["destination_name"],
        destination_name: response.data["destination_type"],
        push_type: response.data["push_type"],
        source_link: response.data["source_link"],
        source_link_label: response.data["source_link_label"],
        destination_link: response.data["destination_link"],
        destination_link_label: response.data["destination_link_label"],
        // selected_version should only come from DAG object, not API response
      });
      
      // Load destination objects and fields for editing
      if (response.data["destination_id"] && response.data["destination_id"].length < 20) {
        // Regular destination 
        this.getDestinationObjects(
          response.data["destination_type"],
          response.data["destination_name"], 
          this.state.selected_version
        );
      } else if (response.data["destination_id"]) {
        // Airbyte destination
        this.getDestinationObjectsAirbyte(
          response.data["destination_type"],
          response.data["destination_id"]
        );
      }
      
      // Load fields for editing
      if (response.data["selected_model"] && !this.isNonV2EditMode()) {
        const selectedModel = response.data["selected_model"];
        // Extract table name from model (e.g., "DATAJOLT_MODELS.HUBSPOT" -> "HUBSPOT")
        const tableName = selectedModel.includes('.') ? selectedModel.split('.').pop() : selectedModel;
        this.getColumns(selectedModel, selectedModel);
      }
      if (response.data["selected_destination_object"]) {
        // Load destination fields
        this.getDestinationFields(response.data["selected_destination_object"]);
      }
    } else {
      this.setState({ activeTab: "all" });
      this.props.router.navigate("/jobs/push");
      this.props.toggleCreatePushForm();
    }
    this.setState({
      progress: 100,
      loading: false,
      loading_spinner_pushes: false,
    });
  };

  saveDestination = async (tap) => {
    this.setState({ progress: 40, saving: true });
    var connection_details = [];
    for (var field in this.state.fields) {
      var field_name = this.state.fields[field];
      connection_details.push({
        [this.state.fields[field]]: this.state[field_name],
      });
    }
    // save destination if this is not an airbyte tap, otherwise skip call
    if (!this.state.destination_id) {
      const savetab = {
        tap_name: tap,
        alias: this.state.destination_alias,
        secrets: connection_details,
      };
      const response = await saveDestinationService(savetab, this.state.selected_version);

      if(response) {
        this.setState({
          selected_datapoint_destination: false,
          source_link: false,
          destination_link: false,
          selected_datapoint_source: false,
          streams: [],
          progress: 100,
          activeTab: "dataset",
          color: "primary",
          destination_id: response.data["destinationId"],
          secrets: connection_details,
        });
        this.getDestinationObjects(
          tap,
          this.state.destination_alias,
          this.state.selected_version
        );
      }
      this.setState({ progress: 100, saving: false });
    } else {
      toast.success("Credentials saved successfully.");
      this.setState({ activeTab: "dataset" });
      this.getDestinationObjectsAirbyte(tap, this.state.destination_id);
    }
  };

  getPushTypes = async (tap) => {
    this.setState({ getting_push_types: true });
    const response = await getPushTypeService(tap, this.state.selected_version);

    if(response) {
      this.setState({ push_types: response.data["push_types"] });
    }
    this.setState({ getting_push_types: false });
  };

  getDestinationObjects = async (destination, destination_alias, version = null) => {
    if (destination === "Tableau") {
      return;
    }
    this.setState({ loading_destination_objects: true });
    this.getPushTypes(destination);

    const versionToUse = version || this.state.selected_version;
    const response = await getDestinationService(destination, destination_alias, versionToUse);

    if(response) {
      let destination_objects = [];
      for (let field in response.data["fields"]) {
        destination_objects.push({
          label: Object.keys(response.data["fields"][field]),
          value: Object.keys(response.data["fields"][field]),
        });
      }
      this.setState({
        fields: response.data["fields"],
        primary_keys: response.data["primary_keys"] || {},
        destination_objects: destination_objects,
      });
      if (this.state.editing) {
        this.getDestinationFields(this.state.selected_destination_object);
      }
    }
    this.setState({ loading_destination_objects: false });
  };

  getDestinationObjectsAirbyte = async (destination, destinationId) => {
    this.setState({
      fields: [],
      destination_objects: [],
      loading_destination_objects: true
    });
    this.getPushTypes(destination);

    const response = await getDestinationObjectsAirbyteService(destinationId);

    if(response) {
      let destination_objects = [];
      for (let field in response.data["fields"]) {
        destination_objects.push({
          label: Object.keys(response.data["fields"][field]),
          value: Object.keys(response.data["fields"][field]),
        });
      }
      this.setState({
        streams: [],
        color: "primary",
        fields: response.data["fields"],
        destination_objects: destination_objects,
      });
      if (this.state.editing) {
        this.getDestinationFields(this.state.selected_destination_object);
      }
    }
    this.setState({
      loading_destination_objects: false,
      progress: 100,
      saving: false,
    });
  };

  getDestinationFields = (object) => {
    this.setState({ selected_destination_object: object });
    if (this.state.selected_tap !== "Google Sheets") {
      var push_fields = [];
      var fieldsObj = this.state.fields.find((obj) => obj.hasOwnProperty(object[0]));
      if (fieldsObj && fieldsObj[object[0]]) {
        var arr = fieldsObj[object[0]];
        
        // Always show all fields for field mapping selection
        // Primary key restriction should only apply to the "Destination ID" dropdown, not general field selection
        for (var field in arr) {
          push_fields.push({
            label: arr[field]["label"],
            value: arr[field]["value"],
          });
        }
      }
      this.setState({ push_fields_options: push_fields }, () => {
        // Trigger validation for edit flow if source fields are ready
        if (this.state.editing && this.state.selected_version === "v2" && this.state.datapoints_options && this.state.fields_mapping) {
          this.validateEditMappings();
        }
      });
    }
  };

  refreshDestinationCatalog = async (tap, destination_alias) => {
    this.setState({ loading_destination_objects: true, progress: 40 });

    const response = await refreshDestinationCatalogService(tap, destination_alias, this.state.selected_version);

    if(response) {
      let destination_objects = [];
      for (let field in response.data["fields"]) {
        destination_objects.push({
          label: Object.keys(response.data["fields"][field]),
          value: Object.keys(response.data["fields"][field]),
        });
      }
      this.setState({
        fields: response.data["fields"],
        primary_keys: response.data["primary_keys"] || {},
        destination_objects: destination_objects,
      });
    }
    this.setState({ loading_destination_objects: false, progress: 100 });
  };

  toggle_modal_cron = () => {
    this.setState({ modal_cron: !this.state.modal_cron });
  };

  testDestination = async () => {
    if (!/[a-zA-Z]/.test(this.state.destination_alias[0])) {
      toast.info("Alias has to start with a letter.");
    } else if (
      /[`!@#$£%^&*()+\-=[\]{};':"\\|,.<>/?~]/.test(
        this.state.destination_alias
      )
    ) {
      toast.info('Alias cannot have any special characters except "_".');
    } else if (
      this.state.mydestinations
        .map((obj) => obj.alias)
        .includes(this.state.destination_alias)
    ) {
      toast.info(
        "A destination called " +
          this.state.destination_alias +
          " already exists"
      );
    } else if (this.state.destination_alias === "") {
      toast.info("Destination alias cannot be empty.");
    } else {
      this.setState({
        selected_destination_object: false,
        selected_model: false,
      });
      let connection_details;
      // need to get inputs from state --> use field names to retrieve from state?
      //for airbyte inputs
      if (this.state.destinationdefinitionID) {
        connection_details = this.state;
      }
      //for custom ones
      else {
        connection_details = [];
        for (var field in this.state.fields) {
          var field_name = this.state.fields[field];
          connection_details.push({
            [this.state.fields[field]]: this.state[field_name],
          });
        }
      }
      this.setState({ progress: 40, testing: true });
      const response = await testDestinationService({
        selected_tap: this.state.selected_tap,
        destination_alias: this.state.destination_alias,
        inputs: connection_details,
        destinationdefinitionId: this.state.destinationdefinitionID,
      }, this.state.selected_version)

      if(response) {
        this.setState({
          color: "success",
          destination_id: response.data["destinationId"],
          sourceID: response.data["sourceId"],
        });
      }

      this.setState({ progress: 100, testing: false });
    }
  };

  createPush = async () => {
    if (!this.state.push_alias || this.state.push_alias.trim() === "") {
      if (this.state.selected_tap === "Tableau") {
        toast.info("Datasource name cannot be empty.");
      } else {
        toast.info("Push alias cannot be empty.");
      }
    } else if (
      this.state.selected_tap !== "Google Sheets" &&
      this.state.selected_tap !== "Tableau" &&
      this.state.selected_tap !== "Copper" &&
      this.state.push_type !== "Append" &&
      this.state.push_type !== "Delete" &&
      (!this.state.push_type ||
        !this.state.source_link ||
        !this.state.destination_link)
    ) {
      toast.info(
        "Unable to create your data push. A link or push type is missing."
      );
    } else if (
      /[^a-zA-Z0-9_]/.test(this.state.push_alias)
    ) {
      if (this.state.selected_tap === "Tableau") {
        toast.info('Datasource name cannot have any special characters except "_".');
      } else {
        toast.info('Push alias cannot have any special characters except "_".');
      }
    } else if (
      this.props.dagsList
        .map((obj) => obj.alias)
        .includes(this.state.push_alias)
    ) {
      toast.info(
        "A push called " +
          this.state.push_alias +
          " already exists"
      );
    } 
    else if (
      this.state.selected_tap === "Google Sheets" &&
      (!this.state.selected_model ||
        !this.state.selected_destination_object ||
        !this.state.push_type)
    ) {
      toast.info(
        "Unable to create your data push. Please double check inputs."
      );
    } else if (
      this.state.selected_tap !== "Google Sheets" &&
      this.state.selected_tap !== "Tableau" &&
      this.state.fields_mapping.some(
        (obj) => obj.source === "" || obj.target === ""
      )
    ) {
      toast.info("You cannot leave a field mapping empty.");
    } else if (
      this.state.selected_version === "v2" &&
      Object.keys(this.state.validation_errors).length > 0
    ) {
      toast.error("Please fix the data type compatibility errors before creating the push.");
    } else {
      this.setState({ creating_push: true });
      const isSuccess = await createPushService({
        destination_id: this.state.destination_id,
        destination_alias: this.state.destination_alias,
        push_type: this.state.push_type,
        mappings: this.state.fields_mapping,
        source_link: this.state.source_link,
        destination_link: this.state.destination_link,
        selected_model: this.state.selected_model,
        selected_destination_object: this.state.selected_destination_object,
        alias: this.state.push_alias,
        selected_push: this.state.selected_tap,
        depends_on: this.state.depends_on,
        selected_version: this.state.selected_version
      });

      if(isSuccess) {
        this.props.toggleCreatePushForm();
        this.props.router.navigate("/jobs/push");
        this.props.fetchAirflowDags();
      }
      this.setState({ creating_push: false });
    }
  };


  gotoSchedulePush = () => {
    if (!this.state.push_alias || this.state.push_alias.trim() === "") {
      if (this.state.selected_tap === "Tableau") {
        toast.error("Datasource name cannot be empty.");
      } else {
        toast.error("Push alias cannot be empty.");
      }
    } else if (
      this.state.selected_tap !== "Google Sheets" &&
      this.state.selected_tap !== "Copper" &&
      this.state.push_type !== "Append" &&
      this.state.push_type !== "Delete" &&
      (!this.state.push_type ||
        !this.state.source_link ||
        !this.state.destination_link)
    ) {
      toast.error(
        "Unable to create your data push. A link or push type is missing."
      );
    } else if (
      this.state.selected_tap === "Google Sheets" &&
      (!this.state.selected_model ||
        !this.state.selected_destination_object ||
        !this.state.push_type)
    ) {
      toast.error(
        "Unable to create your data push. Please double check inputs."
      );
    } else if (
      this.state.selected_tap !== "Google Sheets" &&
      this.state.fields_mapping.some(
        (obj) => obj.source === "" || obj.target === ""
      )
    ) {
      toast.error("You cannot leave a field mapping empty.");
    } else {
      this.setState({ activeTab: "schedule" });
    }
  };

  testPush = async () => {
    if (!this.state.push_alias || this.state.push_alias.trim() === "") {
      if (this.state.selected_tap === "Tableau") {
        toast.error("Datasource name cannot be empty.");
      } else {
        toast.error("Push alias cannot be empty.");
      }
    } else if (
      this.state.selected_tap !== "Google Sheets" &&
      (!this.state.selected_datapoint_source ||
        !this.state.selected_datapoint_destination ||
        !this.state.push_type ||
        !this.state.source_link ||
        !this.state.destination_link)
    ) {
      toast.error(
        "Unable to create your data push. Please double check inputs."
      );
    } else if (
      this.state.selected_tap === "Google Sheets" &&
      (!this.state.selected_model ||
        !this.state.selected_destination_object ||
        !this.state.push_type)
    ) {
      toast.error(
        "Unable to create your data push. Please double check inputs."
      );
    } else {
      let toastId;
      if (this.state.selected_tap !== "Google Sheets") {
        toastId = toast.loading(
          "Testing pushing " +
            this.state.selected_datapoint_source +
            " to " +
            this.state.selected_destination_object +
            " in " +
            this.state.selected_tap +
            " ..."
        );
      } else {
        toastId = toast.loading(
          "Testing pushing " +
            this.state.selected_model +
            " to " +
            this.state.selected_destination_object +
            " in " +
            this.state.selected_tap +
            " ..."
        );
      }
      this.setState({ progress: 40, testing: true, color: "primary" });
      const response = await testPushService({
        gs_url: this.state.gs_url,
        push_type: this.state.push_type,
        destination: this.state.selected_tap,
        model: this.state.selected_model,
        source_fields: this.state.selected_datapoint_source,
        source_unique_id: this.state.source_link,
        destination_object: this.state.selected_destination_object,
        destination_field: this.state.selected_datapoint_destination,
        destination_unique_id: this.state.destination_link,
      }, toastId);

      if(response) {
        this.setState({
          color: "success",
          json_update_endpoint: response.data["json_update_endpoint"],
        });
      }
      this.setState({ progress: 100, testing: false });
    }
  };

  handleDeleteSuccess = () => {
    this.getMyDestinations("newpush");
  };


  renderCloseFormButton = (isLastElm = true) => (
    <Button
      sx={{
        color: "white",
        border: "1px solid #d0d5dd",
        borderRadius: "5px",
        background: "#abaaaa",
        padding: "8.5px 15px",
        fontWeight: "500",
        fontSize: "11px",
        lineHeight: 1.2,
        marginLeft: isLastElm ? "auto" : "unset",
        "&:hover": {
          background: "#abaaaa",
        }
      }}
      onClick={this.handleClosePushForm}
    >
      <Icon.X size={14} style={{ marginRight: "5px", marginBottom: "3px" }} />
      Close
    </Button>
  );

  getMyDestinations = async (activeTab) => {
    this.setState({
      progress: 60,
      mytaps: [],
      mydestinations: [],
      loading_my_destinations: true,
      activeTab: activeTab,
    });
    const response = await getMyDestinationsService();

    if(response) {
      this.setState({ mydestinations: response.data });
    }

    this.setState({ progress: 100, loading_my_destinations: false });
  };

  listConnectors = async () => {
    this.getMyDestinations("newpush");
    this.setState({
      schedule_frequency: false,
      push_alias: "",
      datasources: [],
      loading_connectors: true,
      get_dags_status: false,
      color: "primary",
      progress: 40,
      replication_disabled: true,
      loading_spinner: true,
      activeTab: "newpush",
    });
    
    const response = await listConnectorsService();

    if(response) {
      this.setState({
        saving_settings: false,
        selected_tap: false,
        progress: 100,
        datasources: response.data,
      });
      this.getMyModels(false);
    }
    this.setState({
      loading_connectors: false,
      progress: 100,
      loading_spinner: false,
    });
  };

  toggleLoseCreatePushFormProgressModal = () =>
    this.setState({
      modal_lose_create_push_progress:
        !this.state.modal_lose_create_push_progress,
    });

  handleClosePushForm = () => {
    if (this.state.activeTab === "newpush") {
      this.props.toggleCreatePushForm();
    } else {
      this.toggleLoseCreatePushFormProgressModal();
    }
  };


  handleStateUpdate = (newState) => {
    this.setState(newState);
  };

  isNonV2EditMode = () => {
    return this.state.editing && this.state.selected_version !== 'v2';
  };

  validateEditMappings = () => {
    // Reconstruct labels for existing mappings during edit
    if (this.state.datapoints_options && this.state.push_fields_options && this.state.fields_mapping) {
      const updatedMappings = this.state.fields_mapping.map(mapping => {
        const sourceOption = this.state.datapoints_options.find(opt => opt.value === mapping.source);
        const targetOption = this.state.push_fields_options.find(opt => opt.value === mapping.target);
        
        return {
          ...mapping,
          source_label: sourceOption?.label || mapping.source_label || mapping.source,
          target_label: targetOption?.label || mapping.target_label || mapping.target
        };
      });
      this.setState({ fields_mapping: updatedMappings }, () => {
        this.validateMapping();
      });
    }
  };

  validateMapping = async () => {
    // Only validate if it's a v2 destination with complete mappings
    if (this.state.selected_version !== "v2" || !this.state.destination_alias) {
      return;
    }

    // Check if we have complete field mappings
    const completeMappings = this.state.fields_mapping.filter(
      mapping => mapping.source && mapping.target && mapping.target_label
    );

    if (completeMappings.length === 0) {
      this.setState({ validation_errors: {}, type_mapping: null });
      return;
    }

    this.setState({ validating_mapping: true });

    try {
      // Extract Snowflake types from datapoints_options
      const fieldMappings = {};
      
      completeMappings.forEach(mapping => {
        
        // Try to extract type from source_label first (e.g., "AMOUNT (NUMBER)" -> "NUMBER")
        let snowflakeType = 'VARCHAR'; // default
        
        if (mapping.source_label) {
          const typeMatch = mapping.source_label.match(/\(([^)]+)\)$/);
          if (typeMatch) {
            snowflakeType = typeMatch[1];
          }
        }
        
        // If no type found in source_label, try to find it in datapoints_options
        if (snowflakeType === 'VARCHAR' && this.state.datapoints_options) {
          const sourceOption = this.state.datapoints_options.find(
            option => option.value === mapping.source || option.label === mapping.source_label
          );
          
          if (sourceOption) {
            const typeMatch = sourceOption.label.match(/\(([^)]+)\)$/);
            if (typeMatch) {
              snowflakeType = typeMatch[1];
            }
          }
        }
        
        // Extract destination type from target_label (e.g., "company_name (string)" -> "string")
        const destTypeMatch = mapping.target_label.match(/\(([^)]+)\)$/);
        const destinationType = destTypeMatch ? destTypeMatch[1] : 'string';
        
        
        fieldMappings[`${mapping.source}::${mapping.target}`] = {
          source_type: snowflakeType,
          destination_type: destinationType,
          destination_field: mapping.target
        };
      });

      // Determine endpoint type based on selected destination object
      let endpointType = 'companies'; // default
      if (this.state.selected_destination_object) {
        if (Array.isArray(this.state.selected_destination_object) && this.state.selected_destination_object.length > 0) {
          endpointType = this.state.selected_destination_object[0];
        } else if (typeof this.state.selected_destination_object === 'string') {
          endpointType = this.state.selected_destination_object;
        }
      }

      const validationData = {
        destination_type: this.state.selected_tap,
        destination_alias: this.state.destination_alias,
        endpoint_type: endpointType,
        field_mappings: fieldMappings
      };

      const response = await validateMappingService(validationData);
      
      if (response && response.data) {
        this.setState({
          validation_errors: response.data.errors || {},
          type_mapping: response.data.type_mapping,
          validating_mapping: false
        });
      } else {
        this.setState({
          validating_mapping: false
        });
      }
    } catch (error) {
      console.error("Validation error:", error);
      this.setState({ 
        validation_errors: {},
        validating_mapping: false 
      });
    }
  };

  updateFieldsMapping = (type, index, e) => {
    var fields_mapping = this.state.fields_mapping;
    fields_mapping[index][type] = e.value;
    fields_mapping[index][type + "_label"] = e.label;
    this.setState({ fields_mapping: fields_mapping }, () => {
      // Trigger validation after state update for v2 destinations
      if (this.state.selected_version === "v2") {
        // Debounce validation to avoid too many API calls
        clearTimeout(this.validationTimeout);
        this.validationTimeout = setTimeout(() => {
          this.validateMapping();
        }, 500);
      }
    });
  };

  render() {
    return (
      <div id="push-tap-creator-form">
        <div className="container-fluid py-3">
          <div style={{ display: "flex" }} className="push-tap-collector-form">
            <StepIndicator
              steps={
                this.props.isEditingPush
                  ? ["Settings", "Data"]
                  // : ["Settings", "Data", "Settings"]
                  : ["Destination", "Settings"]
                }
              activeStep={
                this.state.activeTab === "setup"
                  ? 1
                  : this.state.activeTab === "dataset"
                  ? 2
                  : this.state.activeTab === "schedule"
                  ? 3
                  : 0
              }
            />

            <div
              style={{
                width: "80%",
                position: "relative",
              }}
            >
              <Tab.Container id="taps-tabs" activeKey={this.state.activeTab}>
                <Tab.Content>
                  <CSSTransition
                    in={this.state.activeTab === "newpush"}
                    classNames="push-tap-slide"
                    timeout={300}
                    unmountOnExit
                  >
                    <Tab.Pane eventKey="newpush">
                      <div className="card-body push-tap-form">
                        <div className="card form-step-wrapper">
                          <h4 className="d-flex gap-2 align-items-center horizontal-spacing">
                            <b>Destination Connectors </b>
                            <OverlayTrigger
                              trigger="click"
                              placement="right"
                              overlay={
                                <Popover id={`popover-positioned-left`}>
                                  <Popover.Header as="h3">
                                    {"What are Destination Connectors?"}
                                  </Popover.Header>
                                  <Popover.Body>
                                    Destination Connectors are integrations that
                                    you can use to push data to.
                                    <br />
                                    <br />
                                    One destination can have several data
                                    pushes.
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <DetailsIcon />
                            </OverlayTrigger>{" "}
                            {this.renderCloseFormButton()}
                          </h4>

                          <b
                            style={{
                              display: "block",
                              marginLeft: "20px",
                              width: "100%",
                            }}
                          >
                            Your Existing Destinations (
                            {this.state.mydestinations.length})
                          </b>
                          <div className="destinations-push connectors-container">
                            {!this.state.loading_my_destinations ? (
                              this.state.mydestinations.map((mydestination) => (
                                <div
                                  onClick={() =>
                                    this.SelectExistingDestination(
                                      mydestination.alias,
                                      mydestination.logo,
                                      mydestination.id,
                                      mydestination.name,
                                      mydestination.details,
                                      mydestination.version
                                    )
                                  }
                                  className="w-dyn-item"
                                  style={{
                                    display: "inline-block",
                                    marginleft: "5px",
                                  }}
                                >
                                  <div className="w-embed">
                                    <input
                                      type="hidden"
                                      className="jetboost-list-item"
                                    />
                                  </div>
                                  <ConnectorCardPush
                                      datasource={mydestination}
                                      onDeleteSuccess={this.handleDeleteSuccess}
                                    />
                                </div>
                              ))
                            ) : (
                              <center className="connector-spinner">
                                <DatajoltSpinner />
                              </center>
                            )}
                          </div>
                          <b
                            style={{
                              marginLeft: "20px",
                              display: "block",
                              width: "100%",
                              marginTop: "50px",
                            }}
                          >
                            Available Connectors (
                            {this.state.datasources.length})
                          </b>
                          <div className="destinations-push connectors-container">
                            {!this.state.loading_connectors ? (
                              this.state.datasources.length > 0 &&
                              this.state.datasources.map((datasource) => (
                                <div
                                  onClick={() =>
                                    this.getTapDetails(
                                      datasource.value,
                                      datasource.logo,
                                      datasource.destination_group,
                                      datasource.status,
                                      datasource.destinationdefinitionID
                                        ? datasource.destinationdefinitionID
                                        : false,
                                      datasource.version
                                    )
                                  }
                                  className="w-dyn-item"
                                  style={{
                                    display: "inline-block",
                                  }}
                                >
                                  <div className="w-embed">
                                    <input
                                      type="hidden"
                                      className="jetboost-list-item"
                                    />
                                  </div>
                                  <ConnectorCardPush datasource={datasource} />
                                </div>
                              ))
                            ) : (
                              <center className="connector-spinner">
                                <DatajoltSpinner />
                              </center>
                            )}
                          </div>
                        </div>
                      </div>
                    </Tab.Pane>
                  </CSSTransition>

                  <CSSTransition
                    in={this.state.activeTab === "setup"}
                    classNames="push-tap-slide"
                    timeout={300}
                    unmountOnExit
                  >
                    <Tab.Pane eventKey="setup">
                      <div className="card-body push-tap-form">
                        <div className="card form-step-wrapper">
                          <h4 className="d-flex gap-2 align-items-center horizontal-spacing">
                            <b>Destination Details </b>
                            <OverlayTrigger
                              trigger="click"
                              placement="right"
                              overlay={
                                <Popover id={`popover-positioned-left`}>
                                  <Popover.Header as="h3">
                                    {"What are Destinations?"}
                                  </Popover.Header>
                                  <Popover.Body>
                                    Destinations are saved integrations that you
                                    can reuse to push data to.
                                    <br />
                                    <br />
                                    One destination can have several data
                                    pushes.
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <DetailsIcon />
                            </OverlayTrigger>{" "}
                            {this.renderCloseFormButton()}
                          </h4>

                          {this.state.spec_details.length > 0 ? (
                            <>
                              <Row>
                                <Col size={12}>
                                  <Form.Group className="mb-3">
                                    <Form.Label>
                                      <b style={{ marginLeft: "20px" }}>
                                        Destination Alias
                                      </b>
                                    </Form.Label>
                                    <Form.Control
                                      style={{ width: "96%", marginLeft: "3%" }}
                                      type="text"
                                      onChange={(e) =>
                                        this.setState({
                                          destination_alias: e.target.value,
                                        })
                                      }
                                      placeholder="Your destination alias"
                                    />
                                  </Form.Group>
                                  <SpecDetailsForm
                                    spec_details={this.state.spec_details}
                                    onStateUpdate={this.handleStateUpdate}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col size={12}>
                                  <Button
                                    sx={{
                                      marginLeft: "20px",
                                      marginBottom: "20px",
                                      fontSize: "11px",
                                      bgcolor: this.state.color === "primary" ? "#2d49fd" : "#4BBF73",
                                      "&:disabled": {
                                        bgcolor: this.state.color === "primary" ? "#2d49fd" : "#4BBF73",
                                        color: "#fff"
                                      }
                                    }}
                                    type="submit"
                                    variant="contained"
                                    disabled={
                                      this.state.testing
                                        ? true
                                        : this.state.color === "success"
                                        ? true
                                        : false
                                    }
                                    onClick={this.testDestination}
                                  > <Icon.Repeat size={14} />&nbsp;
                                    {this.state.color === "primary"
                                      ? this.state.testing
                                        ? "Testing..."
                                        : "Test & Save"
                                      : this.state.color === "success"
                                      ? "Success"
                                      : ""}
                                    &nbsp;
                                    {this.state.color === "success" ? (
                                      <Icon.Check size={14} />
                                    ) : (
                                      ""
                                    )}
                                    {this.state.testing ? (
                                      <CircularProgress size={14} color="#fff" />
                                    ) : (
                                      ""
                                    )}
                                  </Button>
                                  {this.state.color === "success" ? (
                                    <Button
                                      sx={{
                                        marginLeft: "20px",
                                        marginBottom: "20px",
                                        bgcolor: "#4BBF73",
                                        "&:disabled": {
                                          bgcolor: "#4BBF73",
                                          color: "#fff"
                                        },
                                        fontSize:"11px"
                                      }}
                                      type="submit"
                                      variant="contained"
                                      disabled={this.state.saving}
                                      onClick={() =>
                                        this.saveDestination(
                                          this.state.selected_tap,
                                          1
                                        )
                                      }
                                    ><Icon.Save size={14}/>&nbsp;
                                      {this.state.saving
                                        ? "Saving... "
                                        : "Save Destination"}
                                      {this.state.saving ? (
                                        <CircularProgress size={14} color="#fff" />
                                      ) : (
                                        ""
                                      )}
                                    </Button>
                                  ) : (
                                    ""
                                  )}
                                </Col>
                                <br />
                              </Row>
                            </>
                          ) : (
                            ""
                          )}
                          {this.state.loading_spinner ? (
                            <div className="row">
                              <br></br>
                              <center>
                                <DatajoltSpinner />
                              </center>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </Tab.Pane>
                  </CSSTransition>

                  <CSSTransition
                    in={this.state.activeTab === "dataset"}
                    classNames="push-tap-slide"
                    timeout={300}
                    unmountOnExit
                  >
                    <Tab.Pane eventKey="dataset">
                      <div className="card-body push-tap-form dataset-step push-form">
                        <div className="card form-step-wrapper">
                          <h4 className="d-flex gap-2 align-items-center horizontal-spacing">
                            <b>
                              {!this.state.editing
                                ? "Select data to push to " +
                                  this.state.selected_tap
                                : "Edit your push setup" }{" "}
                            </b>
                            <OverlayTrigger
                              trigger="click"
                              placement="right"
                              overlay={
                                <Popover id={`popover-positioned-left`}>
                                  <Popover.Header as="h3">
                                    {"What are push types?"}
                                  </Popover.Header>
                                  <Popover.Body>
                                    You can select the push type you need in
                                    this screen, it depends on your destination.
                                    <br />
                                    <br />
                                    You can then use mappings to map fields from
                                    your source model to your destination.
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <DetailsIcon />
                            </OverlayTrigger>
                            {this.state.destination_id.length < 20 &&
                            this.state.destination_id !== "pending" &&
                            this.state.selected_tap !== "Google Sheets" &&
                            this.state.selected_tap !== "Tableau"
                            ? (
                              <Button
                                sx={{
                                  marginLeft: "auto",
                                  fontSize: "11px",
                                  height: "34px",
                                  bgcolor: "#495057",
                                  "&:hover":{
                                    bgcolor: "#3e444a"
                                  },
                                  "&:disabled": {
                                    bgcolor: "#495057",
                                    color: "#fff"
                                  }
                                }}
                                type="submit"
                                variant="contained"
                                disabled={
                                  this.state.loading_destination_objects || this.isNonV2EditMode()
                                }
                                onClick={() =>
                                  this.refreshDestinationCatalog(
                                    this.state.selected_tap,
                                    this.state.destination_alias
                                  )
                                }
                              >
                                &nbsp;&nbsp;Refresh destination
                                catalog&nbsp;&nbsp;
                                <Icon.RefreshCw size={14} />
                                &nbsp;&nbsp;
                              </Button>
                            ) : (
                              ""
                            )}{" "}
                            {this.renderCloseFormButton(!(
                              this.state.destination_id.length < 20 &&
                              this.state.destination_id !== "pending" &&
                              this.state.selected_tap !== "Google Sheets" &&
                              this.state.selected_tap !== "Tableau"
                            ))}
                          </h4>
                          <Row>
                            <h6 style={{ marginLeft: "20px", width: "100%" }}>
                              <b>Push Details</b>
                            </h6>
                            <Col size={{ md: 5 }}>
                              {this.state.selected_tap !== "Tableau" && (
                                <Form.Label>
                                  <b style={{ marginLeft: "20px" }}>Push Alias</b>
                                </Form.Label>
                              )}
                              <Form.Control
                                style={{ width: "100%", marginLeft: "20px", height: "38px", fontSize: "11px", fontWeight: "200" }}
                                type="text"
                                onChange={(e) =>
                                  this.setState({
                                    push_alias: e.target.value,
                                  })
                                }
                                value={this.state.push_alias}
                                placeholder={this.state.editing ? "Loading..." : this.state.selected_tap === "Tableau" ? "Your datasource name in Tableau" : "Your push alias"}
                                className="push-alias-input"
                                disabled={this.isNonV2EditMode()}
                              />
                              <div
                                style={{ marginLeft: "20px" }}
                                dangerouslySetInnerHTML={{
                                  __html: this.state.selected_tap === "Tableau" ? "This is the name of your datasource in Tableau." : "This is the alias of your push. It needs to be unique.",
                                }}
                              ></div>
                            </Col>
                            <Col size={{ md: 1 }}>
                              <div
                                style={{
                                  marginTop: "50px",
                                  marginLeft: "50px",
                                }}
                              >
                              </div>
                            </Col>
                            {this.state.selected_tap !== "Tableau" && (
                              <Col size={{ md: 5 }}>
                                <Form.Label>
                                  <b style={{ marginLeft: "20px" }}>Push Type</b>
                                </Form.Label>
                                <Select
                                  maxMenuHeight={150}
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: '100%', // Adjust the width as needed
                                    }),
                                    control: (provided) => ({
                                      ...provided,
                                      height: "38px", // Adjust the height as needed
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      marginLeft: "20px !important",
                                      marginTop: "4px"
                                    })
                                  }}
                                  className={
                                    this.state.editing
                                      ? "react-select-container disabled"
                                      : "react-select-container"
                                  }
                                  value={{
                                    value: this.state.push_type,
                                    label: this.state.push_type,
                                  }}
                                  placeholder="Select a push type..."
                                  isDisabled={
                                    this.isNonV2EditMode() ? true : false
                                  }
                                  classNamePrefix="react-select"
                                  name="dataset_select"
                                  options={this.state.push_types}
                                  onChange={(e) =>
                                    this.setState({ push_type: e.value })
                                  }
                                />
                                <div
                                  style={{ marginLeft: "20px" }}
                                  dangerouslySetInnerHTML={{
                                    __html: "This is the push type to your destination.",
                                  }}
                                ></div>
                              </Col>
                            )}
                          </Row>

                          <hr className="horizontal-spacing" />

                          {this.state.push_type || this.state.selected_tap === "Tableau" ? (
                            <>
                              <Row>
                                <Col size={{ md: 5 }}>
                                  <h6 style={{ marginLeft: "20px" }}>
                                    <b>Source</b>
                                  </h6>
                                  <Form.Label>
                                    <b style={{ marginLeft: "20px" }}>
                                      1. Select a DBT model 
                                    </b>
                                  </Form.Label>
                                  <Select
                                    maxMenuHeight={150}
                                    styles={{
                                      container: (provided) => ({
                                        ...provided,
                                        width: '100%', // Adjust the width as needed
                                      }),
                                      control: (provided) => ({
                                        ...provided,
                                        minWidth: '100%', // Adjust the minimum width as needed
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        width: '100% !important',
                                        marginLeft: "20px !important",
                                        marginTop: 4,
                                      }),
                                    }}
                                    className={
                                      this.isNonV2EditMode() ||
                                      this.state.getting_models
                                        ? "react-select-container disabled"
                                        : "react-select-container"
                                    }
                                    classNamePrefix="react-select"
                                    name="dataset_select"
                                    isDisabled={
                                      this.isNonV2EditMode()
                                        ? true
                                        : this.state.getting_models
                                    }
                                    value={
                                      this.state.depends_on
                                        ? {
                                            value: this.state.depends_on,
                                            label: this.state.depends_on,
                                          }
                                        : null
                                    }
                                    placeholder={this.state.editing ? this.state.selected_model :
                                      this.state.getting_models ? (
                                        <div style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'flex-start'
                                        }}>
                                          Loading...&nbsp;&nbsp;
                                          <CircularProgress size={16} color="#fff" />
                                        </div>
                                      ) : (
                                        "Select a DBT model..."
                                      )
                                    }
                                    options={this.state.options}
                                    onChange={(e) => this.getColumns(e.label,e.value)}
                                  />
                                  <div
                                    style={{ marginLeft: "20px" }}
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        "The data will be pushed to your destination after every run of the <a href='/jobs/overview' target='_blank'>selected model</a>.",
                                    }}
                                  ></div>
                                  {/* Add row count display */}
                                  {!this.state.editing && (this.state.row_count !== null || this.state.loading_row_count) && (
                                    <div style={{ marginLeft: "20px", marginTop: "8px", fontSize: "11px", color: "#6c757d", fontWeight: "400" }}>
                                      {this.state.loading_row_count ? (
                                        <>
                                          <Icon.Loader size={12} style={{ marginRight: "5px", animation: "spin 1s linear infinite" }} />
                                          <style>{`
                                            @keyframes spin {
                                              from { transform: rotate(0deg); }
                                              to { transform: rotate(360deg); }
                                            }
                                          `}</style>
                                          Calculating row count...
                                        </>
                                      ) : (
                                        <>
                                          <Icon.Database size={12} style={{ marginRight: "5px" }} />
                                          Estimated rows pushed: <strong style={{ fontWeight: "500" }}>{this.state.row_count.toLocaleString()}</strong>
                                        </>
                                      )}
                                    </div>
                                  )}
                                </Col>
                                {this.state.selected_tap !== "Tableau" && (
                                <>
                                <Col size={{ md: 1}}>
                                  <div
                                    style={{
                                      marginTop: "50px",
                                      marginLeft: "50px",
                                    }}
                                  >
                                    <Icon.ArrowRightCircle />
                                  </div>
                                </Col>
                                <Col size={{ md: 5}}>
                                  <h6 style={{ marginLeft: "20px" }}>
                                    <b>Destination</b>
                                  </h6>
                                  <Form.Label>
                                    <b style={{ marginLeft: "20px" }}>
                                      2. Select a dataset from your
                                      Destination Object
                                    </b>
                                  </Form.Label>
                                  <Select
                                    maxMenuHeight={150}
                                    style={{ width: "10%" }}
                                    styles={{
                                      menu: (provided) => ({
                                        ...provided,
                                        marginLeft: "20px !important",
                                        marginTop: 4,
                                      }),
                                    }}
                                    className={
                                      this.isNonV2EditMode() ||
                                      this.state.loading_destination_objects
                                        ? "react-select-container disabled"
                                        : "react-select-container"
                                    }
                                    isDisabled={
                                      this.isNonV2EditMode()
                                        ? true
                                        : this.state
                                            .loading_destination_objects
                                    }
                                    classNamePrefix="react-select"
                                    name="dataset_select"
                                    value={
                                      this.state.selected_destination_object
                                        ? {
                                            value:
                                              this.state
                                                .selected_destination_object,
                                            label:
                                              this.state
                                                .selected_destination_object,
                                          }
                                        : null
                                    }
                                    placeholder={
                                      this.state
                                        .loading_destination_objects ? (
                                          <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start'
                                          }}>
                                            Loading...&nbsp;&nbsp;
                                            <CircularProgress size={16} color="#fff" />
                                          </div>

                                        ) : (
                                        "Select a destination object..."
                                      )
                                    }
                                    options={this.state.destination_objects}
                                    onChange={(e) =>
                                      this.getDestinationFields(e.value)
                                    }
                                  />
                                  <div
                                    style={{ marginLeft: "20px" }}
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        "This is the object to push data to in your destination, like a table, a spreadsheet tab, or a salesforce object (Accounts, etc)",
                                    }}
                                  ></div>
                                </Col>
                                </>
                                )}
                              </Row>
                              {this.state.selected_tap !== "Google Sheets" ? (
                                <>
                                  {this.state.push_type === "Upsert" ||
                                    this.state.push_type === "Update" ||
                                    (this.state.push_type === "Create" &&
                                      this.state.selected_tap !== "Copper") ? (
                                    <>
                                      <hr className="horizontal-spacing" />

                                      <h6 style={{ marginLeft: "20px" }}>
                                        <b>Link</b>
                                      </h6>
                                      <Row>
                                        <Col size={{ md: 5 }}>
                                          <Form.Label>
                                            <b style={{ marginLeft: "20px" }}>
                                              3. Source ID
                                            </b>
                                          </Form.Label>
                                          <Select
                                            maxMenuHeight={150}
                                            styles={{
                                              container: (provided) => ({
                                                ...provided,
                                                width: '100%', // Adjust the width as needed
                                              }),
                                              control: (provided) => ({
                                                ...provided,
                                                minWidth: '100%', // Adjust the minimum width as needed
                                              }),
                                              menu: (provided) => ({
                                                ...provided,
                                                width: '100% !important',
                                                marginLeft: "20px !important",
                                                marginTop: 4,
                                              }),
                                            }}
                                            className={
                                              !this.state.datapoints_options || this.isNonV2EditMode()
                                                ? "react-select-container disabled"
                                                : "react-select-container"
                                            }
                                            classNamePrefix="react-select"
                                            name="dataset_select"
                                            isDisabled={
                                              !this.state.datapoints_options || this.isNonV2EditMode()
                                            }
                                            placeholder={
                                              this.state
                                                .loading_datapoints ? (
                                                <div style={{
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'flex-start'
                                                }}>
                                                  Loading...&nbsp;&nbsp;
                                                  <CircularProgress size={16} color="#fff" />
                                                </div>
                                              ) : (
                                                "Select a source link..."
                                              )
                                            }
                                            // Only Upsert consumes a multi-column link. Update keys
                                            // an API destination's records on this value as a single
                                            // field name (push_core), so a comma-joined key would
                                            // silently match nothing.
                                            isMulti={this.state.push_type === "Upsert"}
                                            value={
                                              this.state.push_type === "Upsert"
                                                ? linkOptions(this.state.source_link, this.state.source_link_label)
                                                : { value: this.state.source_link, label: this.state.source_link_label }
                                            }
                                            options={
                                              this.state.datapoints_options
                                            }
                                            onChange={(selected) => {
                                              const chosen = Array.isArray(selected)
                                                ? selected
                                                : selected
                                                ? [selected]
                                                : [];
                                              this.setState({
                                                source_link: chosen.map((o) => o.value).join(","),
                                                source_link_label: chosen.map((o) => o.label).join(","),
                                              }, () => {
                                                this.validateSourceId();
                                              });
                                            }}
                                          />
                                          <div
                                            style={{ marginLeft: "20px" }}
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                "This is the unique ID in your source that will link to your destination, like a Customer ID.",
                                            }}
                                          ></div>
                                          {/* Loading state */}
                                          {this.state.loading_source_id_validation && (
                                            <div style={{ marginLeft: "20px", marginTop: "8px", fontSize: "11px", color: "#6c757d", fontWeight: "400", display: "flex", alignItems: "center" }}>
                                              <Icon.Loader size={12} style={{ marginRight: "5px", animation: "spin 1s linear infinite" }} />
                                              <style>{`
                                                @keyframes spin {
                                                  from { transform: rotate(0deg); }
                                                  to { transform: rotate(360deg); }
                                                }
                                              `}</style>
                                              <span>Checking for duplicates and nulls in your source ID...</span>
                                            </div>
                                          )}
                                          
                                          {/* Validation results */}
                                          {this.state.source_id_validation && (
                                            <div style={{ marginLeft: "20px", marginTop: "8px", fontSize: "11px", color: "#6c757d", fontWeight: "400" }}>
                                              {/* Uniqueness check */}
                                              <div style={{ display: "flex", alignItems: "center", marginBottom: "3px" }}>
                                                {this.state.source_id_validation.isUnique ? (
                                                  <>
                                                    <Icon.Check size={12} style={{ marginRight: "5px", color: "#28a745" }} />
                                                    <span style={{ color: "#28a745" }}>{this.state.source_id_validation.fieldName} values are all unique</span>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Icon.X size={12} style={{ marginRight: "5px", color: "#dc3545" }} />
                                                    <span style={{ color: "#dc3545" }}>{this.state.source_id_validation.fieldName} has <strong style={{ fontWeight: "500", color: "#dc3545" }}>{this.state.source_id_validation.duplicateCount.toLocaleString()}</strong> duplicates</span>
                                                  </>
                                                )}
                                              </div>
                                              
                                              {/* NULL check */}
                                              <div style={{ display: "flex", alignItems: "center" }}>
                                                {!this.state.source_id_validation.hasNulls ? (
                                                  <>
                                                    <Icon.Check size={12} style={{ marginRight: "5px", color: "#28a745" }} />
                                                    <span style={{ color: "#28a745" }}>{this.state.source_id_validation.fieldName} doesn't have any NULLs</span>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Icon.X size={12} style={{ marginRight: "5px", color: "#dc3545" }} />
                                                    <span style={{ color: "#dc3545" }}>{this.state.source_id_validation.fieldName} has <strong style={{ fontWeight: "500", color: "#dc3545" }}>{this.state.source_id_validation.nullCount.toLocaleString()}</strong> null values</span>
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                          )}
                                        </Col>
                                        <Col size={{ md: 1 }}>
                                          <div
                                            style={{
                                              marginTop: "20px",
                                              marginLeft: "50px",
                                            }}
                                          >
                                            <Icon.Link />
                                          </div>
                                        </Col>
                                        <Col size={{ md: 5 }}>
                                          <Form.Label>
                                            <b style={{ marginLeft: "20px" }}>
                                              4. Destination ID
                                            </b>
                                          </Form.Label>
                                                                    <Select
                            maxMenuHeight={150}
                            style={{ width: "10%" }}
                            className={
                              !this.state.selected_destination_object || this.isNonV2EditMode()
                                ? "react-select-container disabled"
                                : "react-select-container"
                            }
                            classNamePrefix="react-select"
                            name="dataset_select"
                            isDisabled={
                              !this.state.selected_destination_object || this.isNonV2EditMode()
                            }
                                            placeholder={
                                              this.state
                                                .selected_destination_object
                                                ? "Select a destination link..."
                                                : "Select an object from your destination in step 2."
                                            }
                                            isMulti={this.state.push_type === "Upsert"}
                                            value={
                                              this.state.push_type === "Upsert"
                                                ? linkOptions(this.state.destination_link, this.state.destination_link_label)
                                                : { value: this.state.destination_link, label: this.state.destination_link_label }
                                            }
                                            options={
                                              // Upsert conflicts on a unique index, which may span
                                              // several columns and need not be the declared primary
                                              // key, so offer every destination field. Update still
                                              // links on the primary key alone.
                                              this.state.push_type === "Upsert"
                                                ? this.state.push_fields_options || []
                                                : this.state.push_fields_options && this.state.selected_destination_object && this.state.primary_keys[this.state.selected_destination_object[0]]
                                                ? this.state.push_fields_options.filter(option =>
                                                    this.state.primary_keys[this.state.selected_destination_object[0]] === option.value
                                                  )
                                                : []
                                            }
                                            onChange={(selected) => {
                                              const chosen = Array.isArray(selected)
                                                ? selected
                                                : selected
                                                ? [selected]
                                                : [];
                                              this.setState({
                                                destination_link: chosen.map((o) => o.value).join(","),
                                                destination_link_label: chosen.map((o) => o.label).join(","),
                                              });
                                            }}
                                          />
                                          <div
                                            style={{ marginLeft: "20px" }}
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                "This is the unique ID in your destination that will link to your source, like a Customer ID.",
                                            }}
                                          ></div>
                                        </Col>
                                      </Row>
                                      <br />
                                    </>
                                  ) : (
                                    ""
                                  )}
                                  <hr className="horizontal-spacing" />
                                  {this.state.selected_tap !== "Tableau" && (
                                  <>
                                  <div style={{ 
                                    marginLeft: "20px", 
                                    display: "flex", 
                                    alignItems: "center", 
                                    gap: "15px" 
                                  }}>
                                    <h6 style={{ margin: 0 }}>
                                      <b>Fields Mapping</b>
                                    </h6>
                                    <Button
                                            sx={{
                                              color: "white",
                                              fontSize: "11px",
                                              fontWeight: "bold",
                                              minWidth: "20px",
                                              bgcolor: "#2d49fd",
                                              borderRadius: "4px",
                                              "&:disabled": {
                                                bgcolor: "#2d49fd",
                                                color: "#fff"
                                              }
                                            }}
                                            type="submit"
                                            variant="contained"
                                            size="small"
                                            disabled={this.isNonV2EditMode()}
                                            onClick={() =>
                                              this.setState({
                                                fields_mapping: [
                                                  ...this.state.fields_mapping,
                                                  { source: "", target: "" },
                                                ],
                                              })
                                            }
                                          >
                                            +
                                          </Button>
                                  </div>
                                  {/* Field Mapping Headers */}
                                  <Row style={{ marginBottom: "15px" }}>
                                    <Col size={{ md: 5 }}>
                                      <Form.Label>
                                        <b style={{ marginLeft: "20px" }}>
                                          {this.state.push_type !== "Append" &&
                                          this.state.push_type !== "Delete" &&
                                          this.state.selected_tap !== "Copper"
                                            ? "5"
                                            : "4"}
                                          . Select a data point from your
                                          selected model
                                        </b>
                                      </Form.Label>
                                      {this.state.push_type === "Delete" ? (
                                        <div
                                          style={{ marginLeft: "20px" }}
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              "This is the datapoint(s) you want to delete in your destination on every run.",
                                          }}
                                        ></div>
                                      ) : (
                                        <div
                                          style={{ marginLeft: "20px" }}
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              "This is the datapoint(s) you want to push to your destination on every run.",
                                          }}
                                        ></div>
                                      )}
                                    </Col>
                                    <Col size={{ md: 1 }}></Col>
                                    <Col size={{ md: 5 }}>
                                      <Form.Label>
                                        <b style={{ marginLeft: "20px" }}>
                                          {this.state.push_type !== "Append" &&
                                          this.state.push_type !== "Delete" &&
                                          this.state.selected_tap !== "Copper"
                                            ? "6"
                                            : "5"}
                                          . Select{" "}
                                          {this.state.push_type !== "Delete"
                                            ? "the field you want to send data to"
                                            : "the ID you want to delete data for"}
                                        </b>
                                      </Form.Label>
                                      {this.state.push_type === "Delete" ? (
                                        <div
                                          style={{ marginLeft: "20px" }}
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              "This is the datapoint(s) you want to delete in your destination on every run.",
                                          }}
                                        ></div>
                                      ) : (
                                        <div
                                          style={{ marginLeft: "20px" }}
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              "This is the datapoint(s) you want to update in your destination on every run.",
                                          }}
                                        ></div>
                                      )}
                                    </Col>
                                  </Row>

                                  {/* Field Mapping Rows */}
                                  {this.state.fields_mapping.map((mapping, index) => (
                                    <Row key={index} style={{ marginBottom: "10px", alignItems: "center" }}>
                                      {/* Source Field */}
                                      <Col size={{ md: 5 }}>
                                        <div style={{ position: "relative" }}>
                                          <Select
                                            menuPlacement="top"
                                            maxMenuHeight={150}
                                            styles={{
                                              container: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                              }),
                                              control: (provided) => ({
                                                ...provided,
                                                minWidth: '100%',
                                              }),
                                              menu: (provided) => ({
                                                ...provided,
                                                width: '100% !important',
                                                marginLeft: "20px !important",
                                                marginTop: 4,
                                                zIndex: 9999, // Ensure dropdown menu appears above validation icons
                                              }),
                                            }}
                                            classNamePrefix="react-select"
                                            name="dataset_select"
                                            className={
                                              this.state.loading_destination_objects || this.isNonV2EditMode()
                                                ? "react-select-container disabled"
                                                : "react-select-container"
                                            }
                                            isDisabled={!this.state.selected_model || this.isNonV2EditMode()}
                                            value={{
                                              value: mapping["source"],
                                              label: mapping["source_label"],
                                            }}
                                            options={this.state.datapoints_options}
                                            onChange={(e) =>
                                              this.updateFieldsMapping("source", index, e)
                                            }
                                          />
                                          
                                          {/* Validation status icon for source - positioned inside dropdown with lower z-index */}
                                          {this.state.selected_version === "v2" && mapping.source && mapping.target && (
                                            <div style={{
                                              position: "absolute",
                                              top: "50%",
                                              right: "10px",
                                              transform: "translateY(-50%)",
                                              zIndex: 1, // Lower z-index so dropdown menu appears above
                                              pointerEvents: "none" // Prevent interference with dropdown interaction
                                            }}>
                                              {this.state.validating_mapping ? (
                                                <CircularProgress size={16} />
                                              ) : this.state.validation_errors[`${mapping.source}::${mapping.target}`] ? (
                                                <Icon.AlertCircle size={16} style={{ color: "#d32f2f" }} />
                                              ) : (
                                                <Icon.CheckCircle size={16} style={{ color: "#2e7d32" }} />
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </Col>
                                      
                                      {/* Arrow */}
                                      <Col size={{ md: 1 }}>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            height: "40px",
                                          }}
                                        >
                                          <Icon.ArrowRightCircle />
                                        </div>
                                      </Col>
                                      
                                      {/* Target Field */}
                                      <Col size={{ md: 5 }}>
                                        <div style={{ position: "relative" }}>
                                          <Select
                                            menuPlacement="top"
                                            maxMenuHeight={150}
                                            style={{ width: "100%" }}
                                            className={
                                              !this.state.selected_destination_object || this.isNonV2EditMode()
                                                ? "react-select-container disabled"
                                                : "react-select-container"
                                            }
                                            classNamePrefix="react-select"
                                            name="dataset_select"
                                            isDisabled={!this.state.selected_destination_object || this.isNonV2EditMode()}
                                            value={{
                                              value: mapping["target"],
                                              label: mapping["target_label"],
                                            }}
                                            placeholder={
                                              this.state.selected_destination_object
                                                ? "Select a target field..."
                                                : "Select an object from your destination in step 2."
                                            }
                                            options={this.state.push_fields_options}
                                            onChange={(e) =>
                                              this.updateFieldsMapping("target", index, e)
                                            }
                                          />
                                          
                                          {/* Remove button for additional mappings */}
                                          {index > 0 && (
                                            <Button
                                              disabled={this.isNonV2EditMode()}
                                              onClick={() =>
                                                this.setState({
                                                  fields_mapping:
                                                    this.state.fields_mapping.filter(
                                                      (value, index_) => index_ !== index
                                                    ),
                                                })
                                              }
                                              variant="contained"
                                              sx={{
                                                position: "absolute",
                                                top: "50%",
                                                right: "-50px",
                                                transform: "translateY(-50%)",
                                                color: "#020202",
                                                bgcolor: "#eff2f6",
                                                padding: "0.25rem 0.7rem",
                                                minWidth: 0,
                                                "&:disabled": {
                                                  color: "#020202",
                                                  bgcolor: "#eff2f6",
                                                }
                                              }}
                                            >
                                              <Icon.X size={14} />
                                            </Button>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                  ))}

                                  </>
                                  )}
                                  
                                  {/* Validation Summary */}
                                  {this.state.selected_version === "v2" && Object.keys(this.state.validation_errors).length > 0 && (
                                    <Row style={{ marginTop: "20px" }}>
                                      <Col size={12}>
                                        <div style={{ 
                                          marginLeft: "20px", 
                                          marginRight: "20px",
                                          padding: "15px", 
                                          backgroundColor: "#fff3cd", 
                                          borderRadius: "6px",
                                          border: "1px solid #ffeaa7"
                                        }}>
                                          <div style={{ 
                                            fontSize: "14px", 
                                            fontWeight: "600", 
                                            marginBottom: "10px",
                                            color: "#856404",
                                            display: "flex",
                                            alignItems: "center"
                                          }}>
                                            <Icon.AlertTriangle size={16} style={{ marginRight: "8px" }} />
                                            Data Type Compatibility Issues
                                          </div>
                                          <div style={{ fontSize: "12px", color: "#856404", marginBottom: "10px" }}>
                                            The following field mappings have type compatibility issues that need to be resolved:
                                          </div>
                                          <div style={{ fontSize: "12px" }}>
                                            {Object.entries(this.state.validation_errors).map(([fieldName, errors]) => {
                                              const [sourceField, targetField] = fieldName.split('::');
                                              return (
                                              <div key={fieldName} style={{
                                                padding: "8px 12px",
                                                marginBottom: "8px",
                                                backgroundColor: "#fff",
                                                borderRadius: "4px",
                                                border: "1px solid #f5c6cb"
                                              }}>
                                                <div style={{
                                                  fontWeight: "600",
                                                  color: "#721c24",
                                                  marginBottom: "4px"
                                                }}>
                                                  Mapping: {sourceField} → {targetField}
                                                </div>
                                                {errors.map((error, index) => (
                                                  <div key={index} style={{
                                                    color: "#721c24",
                                                    fontSize: "11px"
                                                  }}>
                                                    {error}
                                                  </div>
                                                ))}
                                              </div>
                                              );
                                            })}
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                  
                                  {/* Type Mapping Reference */}
                                  {this.state.selected_version === "v2" && this.state.type_mapping && (
                                    <Row style={{ marginTop: "20px" }}>
                                      <Col size={12}>
                                        <div style={{ 
                                          marginLeft: "20px", 
                                          marginRight: "20px",
                                          padding: "15px", 
                                          backgroundColor: "#f8f9fa", 
                                          borderRadius: "6px",
                                          border: "1px solid #e9ecef"
                                        }}>
                                          {/* Expandable Header */}
                                          <div 
                                            style={{ 
                                              fontSize: "14px", 
                                              fontWeight: "600", 
                                              marginBottom: this.state.showTypeMapping ? "10px" : "0",
                                              color: "#2d49fd",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "space-between",
                                              cursor: "pointer"
                                            }}
                                            onClick={() => this.setState({ showTypeMapping: !this.state.showTypeMapping })}
                                          >
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                              <Icon.Info size={16} style={{ marginRight: "8px" }} />
                                              HubSpot Data Type Compatibility Reference
                                            </div>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                              {this.state.showTypeMapping ? (
                                                <Icon.ChevronUp size={16} />
                                              ) : (
                                                <Icon.ChevronDown size={16} />
                                              )}
                                            </div>
                                          </div>
                                          
                                          {/* Expandable Content */}
                                          {this.state.showTypeMapping && (
                                            <div style={{
                                              transition: "all 0.3s ease-in-out"
                                            }}>
                                              <div style={{ fontSize: "12px", color: "#666", marginBottom: "10px" }}>
                                                These are the Snowflake data types that are compatible with each HubSpot field type:
                                              </div>
                                              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "10px" }}>
                                                {Object.entries(this.state.type_mapping).map(([hubspotType, snowflakeTypes]) => (
                                                  <div key={hubspotType} style={{
                                                    padding: "8px 12px",
                                                    backgroundColor: "#fff",
                                                    borderRadius: "4px",
                                                    border: "1px solid #dee2e6"
                                                  }}>
                                                    <div style={{
                                                      fontWeight: "600",
                                                      fontSize: "12px",
                                                      color: "#495057",
                                                      marginBottom: "4px"
                                                    }}>
                                                      {hubspotType.toUpperCase()}
                                                    </div>
                                                    <div style={{
                                                      fontSize: "11px",
                                                      color: "#6c757d"
                                                    }}>
                                                      {snowflakeTypes.join(", ")}
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                  
                                  <Row></Row>
                                  <br />
                                </>
                              ) : (
                                ""
                              )}{" "}
                            </>
                          ) : (
                            ""
                          )}
                          <Row>
                            <Col size={12}>
                              {!this.state.editing ? (
                                <Button
                                sx={{
                                  marginLeft: "20px",
                                  marginBottom: "20px",
                                  fontSize: "11px",
                                  fontWeight: 500,
                                  height: "32px",
                                  padding: "0 16px",
                                  textTransform: "none",
                                  borderRadius: "6px",
                                  background: "#2D49FD",
                                  border: "1px solid #2D49FD",
                                  "&:hover": {
                                    bgcolor: this.state.color === "primary" ? "#2d49fd" : "#66c988",
                                  },
                                  "&:disabled": {
                                    bgcolor: this.state.color === "primary" ? "#2d49fd" : "#4BBF73",
                                    color: "#fff"
                                  }    
                                }}  
                                type="submit"
                                  variant="contained"
                                  disabled={this.state.creating_push}
                                  onClick={() => this.createPush()}
                                >
                                  {" "}
                                  {this.state.color === "primary"
                                    ? this.state.testing || this.state.creating_push
                                      ? "Creating... "
                                      : "Create push"
                                    : this.state.color === "success"
                                    ? "Success"
                                    : ""}
                                  &nbsp;                                    
                                  {this.state.creating_push ? (
                                    <CircularProgress size={14} color="#fff" />
                                  ) : (
                                    <Icon.UploadCloud size={14}/>
                                  )}
                                </Button>
                              ) : (
                                <Button
                                  sx={{
                                    marginLeft: "20px",
                                    marginBottom: "20px",
                                    fontSize: "11px",
                                    fontWeight: 500,
                                    height: "32px",
                                    padding: "0 16px",
                                    textTransform: "none",
                                    borderRadius: "6px",
                                    background: "#2D49FD",
                                    border: "1px solid #2D49FD",
                                    "&:hover": {
                                      bgcolor: "#2d49fd",
                                    },
                                    "&:disabled": {
                                      bgcolor: "#2d49fd",
                                      color: "#fff"
                                    }
                                  }}
                                  type="submit"
                                  variant="contained"
                                  disabled={this.state.testing || this.isNonV2EditMode() || this.state.push_type === "Upsert"}
                                  onClick={this.applyEdit}
                                >
                                  {this.state.testing ? "Saving... " : "Update push"}
                                  &nbsp;&nbsp;                                    
                                  {this.state.testing ? (
                                    <CircularProgress size={14} color="#fff" />
                                  ):(
                                    <Icon.UploadCloud size={14}/>
                                  )}
                                </Button>
                              )}
                            </Col>
                            <br />
                          </Row>
                          {this.state.loading_spinner ? (
                            <div className="row">
                              <br></br>
                              <center>
                                <CircularProgress size={16} color="#fff" />
                                <br />  
                                <br />
                              </center>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </Tab.Pane>
                  </CSSTransition>

                  <CSSTransition
                    in={this.state.activeTab === "schedule"}
                    classNames="push-tap-slide"
                    timeout={300}
                    unmountOnExit
                  >
                    <Tab.Pane eventKey="schedule">
                      <div className="card-body push-tap-form">
                        <div className="card form-step-wrapper">
                          <h4 className="d-flex gap-2 align-items-center horizontal-spacing">
                            <b>Schedule your {this.state.selected_tap} push</b>
                            <OverlayTrigger
                              trigger="click"
                              placement="right"
                              overlay={
                                <Popover id={`popover-positioned-left`}>
                                  <Popover.Header as="h3">
                                    {"What are Scheduled Refreshes?"}
                                  </Popover.Header>
                                  <Popover.Body>
                                    This page allows you to set a refresh
                                    cadence so Datajolt knows when to pull data
                                    from your source systems to your DWH
                                    <br />
                                    <br />
                                    This cadence should be aligned with your
                                    business requirements and data consumption.
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <DetailsIcon />
                            </OverlayTrigger>{" "}
                            {this.renderCloseFormButton()}
                          </h4>

                          <Row>
                            <Col size={12}>
                              <Form.Group className="mb-3">
                                <Form.Label>
                                  <b style={{ marginLeft: "20px", fontSize: "12px" }}>
                                    {this.state.selected_tap === "Tableau" ? "Datasource Name" : "Push Alias"}
                                  </b>
                                </Form.Label>
                                <Form.Control
                                  style={{
                                    marginLeft: "20px",
                                    width: "80%",
                                  }}
                                  type="text"
                                  onChange={(e) =>
                                    this.setState({
                                      push_alias: e.target.value,
                                    })
                                  }
                                  value={this.state.push_alias}
                                  placeholder="Your push alias"
                                  disabled={this.state.editing}
                                />
                                <div
                                  style={{ marginLeft: "20px" }}
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      this.state.selected_tap === "Tableau" ? "This is the name of your datasource in Tableau." : "This is the alias of your push. It needs to be unique.",
                                  }}
                                ></div>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col size={12}>
                              <Button
                                sx={{
                                  marginLeft: "20px",
                                  marginBottom: "20px",
                                  bgcolor: "#2d49fd",
                                  "&:disabled": {
                                    bgcolor: "#2d49fd",
                                    color: "#fff"
                                  }
                                }}
                                type="submit"
                                variant="contained"
                                size="large"
                                disabled={this.state.scheduling}
                                onClick={() => this.schedulePush()}
                              >
                                <Icon.Repeat size={14} />
                                &nbsp;&nbsp;
                                {this.state.scheduling
                                  ? "Saving... "
                                  : "Saving your push"}
                                {this.state.scheduling ? (
                                  <CircularProgress size={16} color="#fff" />
                                ) : (
                                  ""
                                )}
                              </Button>
                            </Col>
                          </Row>
                          {this.state.logs_schedule ? (
                            <Alert
                              variant={this.state.logs_schedule_variant}
                              className="alert-outline-coloured"
                              key="1"
                              onClose={() =>
                                this.setState({ logs_schedule: false })
                              }
                              dismissible
                            >
                              <div className="alert-icon">
                                <Icon.X size={16} />
                              </div>
                              <div className="alert-message">
                                <strong>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: this.state.logs_schedule,
                                    }}
                                  />
                                </strong>
                              </div>
                            </Alert>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </Tab.Pane>
                  </CSSTransition>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
          
          <ModalLayout isShown={this.state.modal_lose_create_push_progress} onHide={() => this.setState({ modal_lose_create_push_progress: false })}>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              position={"relative"}
              padding={"16px 24px"}
              borderBottom={"1px solid rgba(0,0,0,0.05)"}
              sx={{ background: "rgba(255,237,237,0.6)" }}
            >
              <DialogTitle
                padding={"0 !important"}
                sx={{
                  color: "#e63946",
                  fontWeight: 800,
                  fontSize: "11px",
                  display: "flex",
                  alignItems: "center",
                  "::before": {
                    content: '""',
                    display: "inline-block",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#e63946",
                    marginRight: "10px",
                    animation: "pulse 1.5s infinite",
                    "@keyframes pulse": {
                      "0%": { boxShadow: "0 0 0 0 rgba(230, 57, 70, 0.7)" },
                      "70%": { boxShadow: "0 0 0 10px rgba(230, 57, 70, 0)" },
                      "100%": { boxShadow: "0 0 0 0 rgba(230, 57, 70, 0)" }
                    }
                  }
                }}
              >
                Warning!
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={() => this.setState({ modal_lose_create_push_progress: false })}
                sx={{
                  position: "absolute",
                  right: 16,
                  top: 10,
                  color: "#495057",
                  "&:hover": {
                    background: "rgba(0,0,0,0.05)",
                    transform: "rotate(90deg)",
                    transition: "transform 0.3s ease"
                  }
                }}
              >
                <Icon.X size={16} />
              </IconButton>
            </Stack>
            <ModalLayoutContent sx={{ padding: "24px 28px" }}>
              <DialogContentText
                textAlign={"center"}
                color="#4a4a4a"
                sx={{ fontSize: "11px", lineHeight: 1.6 }}
              >
                You are about to close without saving your progress, all the progress will be lost.
                <Typography
                  component={"span"}
                  fontWeight={700}
                  display={"block"}
                  fontSize={"11px"}
                  sx={{
                    color: "#721c24",
                    background: "rgba(248,215,218,0.5)",
                    margin: "16px auto 0",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    border: "1px dashed rgba(220,53,69,0.3)",
                    maxWidth: "90%"
                  }}
                >
                  Are you sure?
                </Typography>
              </DialogContentText>
            </ModalLayoutContent>
            <ModalLayoutFooter sx={{ padding: "16px 24px", gap: "12px" }}>
              <ModalLayoutBtn 
                color="default"
                onClick={() => this.setState({ modal_lose_create_push_progress: false })}
                sx={{
                  fontSize: "11px",
                  borderRadius: "8px",
                  fontWeight: 600,
                  textTransform: "none",
                  boxShadow: "none",
                  transition: "all 0.2s",
                  padding: "8px 16px",
                  color: "#5a6268",
                  background: "linear-gradient(45deg, #f5f5f5, #e9ecef)",
                  border: "1px solid #dee2e6",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    background: "linear-gradient(45deg, #e9ecef, #dee2e6)",
                  }
                }}
              >
                <Icon.X size={16} style={{ marginRight: "6px" }} /> Cancel
              </ModalLayoutBtn>
              <ModalLayoutBtn
                color="error"
                onClick={() => {
                  this.toggleLoseCreatePushFormProgressModal();
                  this.props.toggleCreatePushForm();
                }}
                sx={{
                  fontSize: "11px",
                  borderRadius: "8px",
                  fontWeight: 600,
                  textTransform: "none",
                  padding: "8px 20px",
                  transition: "all 0.2s",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 4px 8px rgba(211,47,47,0.25)"
                  }
                }}
              >
                <Icon.X size={16} style={{ marginRight: "6px" }} /> Close
              </ModalLayoutBtn>
            </ModalLayoutFooter>
          </ModalLayout>
        </div>
      </div>
    );
  }
}

export default WithRouter(Push);